import { render, staticRenderFns } from "./TableHistory.vue?vue&type=template&id=1f2406e2&scoped=true"
import script from "./TableHistory.vue?vue&type=script&lang=js"
export * from "./TableHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2406e2",
  null
  
)

export default component.exports